import React from 'react';
import { Cpu, Armchair, Disc3, Gamepad2, Monitor, Speaker, LayoutDashboard, CircleDot } from 'lucide-react';

const SPECS = [
  { key: 'spec_cockpit', label: 'Cockpit', icon: LayoutDashboard },
  { key: 'spec_seat', label: 'Seat', icon: Armchair },
  { key: 'spec_wheelbase', label: 'Wheelbase', icon: Cpu },
  { key: 'spec_pedals', label: 'Pedals', icon: Disc3 },
  { key: 'spec_steering_wheel', label: 'Steering Wheel', icon: CircleDot },
  { key: 'spec_dashboard', label: 'Dashboard', icon: Gamepad2 },
  { key: 'spec_displays', label: 'Displays', icon: Monitor },
  { key: 'spec_pc', label: 'PC Specifications', icon: Cpu },
  { key: 'spec_audio', label: 'Audio System', icon: Speaker },
];

export default function ShowcaseSpecs({ rig }) {
  const filled = SPECS.filter((s) => rig[s.key]);
  if (filled.length === 0) return null;

  return (
    <section className="py-20 px-6 lg:px-10 border-t border-white/5 bg-[#111115]">
      <div className="max-w-7xl mx-auto">
        <p className="text-primary text-xs font-bold tracking-widest mb-3">TECHNICAL SPECIFICATIONS</p>
        <h2 className="text-white font-black text-3xl md:text-4xl uppercase mb-10">Built With The Best</h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 border border-white/5">
          {SPECS.map((s) => {
            const Icon = s.icon;
            const value = rig[s.key];
            if (value) {
              return (
                <div key={s.key} className="bg-[#111115] p-6 hover:bg-[#1a1a1f] transition-colors">
                  <div className="flex items-center gap-2.5 mb-3">
                    <div className="w-7 h-7 bg-primary/10 border border-primary/20 flex items-center justify-center">
                      <Icon className="w-3.5 h-3.5 text-primary" />
                    </div>
                    <span className="text-white/40 text-[10px] font-bold tracking-widest uppercase">{s.label}</span>
                  </div>
                  <p className="text-white text-sm font-medium leading-relaxed">{value}</p>
                </div>
              );
            }
            return (
              <div key={s.key} className="bg-[#0d0d0f] p-6 flex flex-col justify-between">
                <div className="flex items-center gap-2.5 mb-3">
                  <div className="w-7 h-7 border border-dashed border-white/10 flex items-center justify-center">
                    <Icon className="w-3.5 h-3.5 text-white/15" />
                  </div>
                  <span className="text-white/20 text-[10px] font-bold tracking-widest uppercase">{s.label}</span>
                </div>
                <p className="text-white/20 text-sm italic">Not specified</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}